import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { CallBackNotifyTheme } from 'modules/theme';
import { globalStateSelector } from 'store/selector';
import { globalAction, callAction, messageAction } from 'store/action';
import { Alert } from 'modules/common/utils';
import CommonManager from '../../../helpers/common';
const commonManager = new CommonManager();

export class CallBackNotify extends Component {
  constructor(props){
    super(props);
    this.onClickAcceptBtn =  this.onClickAcceptBtn.bind(this);
    this.onClickDeclineBtn =  this.onClickDeclineBtn.bind(this);
    this.sendMessage =  this.sendMessage.bind(this);
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  onClickAcceptBtn(){
    const { callProcess, dynamicUpdate, configProcessor, cbInfo, isCallbackDial } = this.props;
    let detail  = cbInfo.detail && cbInfo.detail.detail ? cbInfo.detail.detail : {};
    let customerNo  = cbInfo.detail && cbInfo.detail.customerNo ? cbInfo.detail.customerNo : {};
    let team   = detail.team || {};
    let custInfo   = detail.custInfo && detail.custInfo.info ? detail.custInfo.info : {};
    if( customerNo && team.id ){

      let messageData = {
        phoneNumber: customerNo,
        teamId : team.id,
        teamName : team.name || "",
        info : {
          leadset : detail.leadset || {},
          campaign : detail.campaign || {},
          callingMode : "callback",
          custInfo : {
            ...custInfo
          }
        },
      };
      callProcess('callInitiate', messageData);
      dynamicUpdate({ key: 'cbNotify', value: false });
      dynamicUpdate({ key: 'cbInfo', value: "" });
      configProcessor('schedule:delete', {
        "scedularId": cbInfo.detail && cbInfo.detail._id ? cbInfo.detail._id : ""
      });
    } else {
      // Alert.error(`CallBack Phone Number Not Found`);
      this.onClickDeclineBtn();
    }
    // update customer info
    // try {

    //   dynamicUpdate({"key":"custInfo",
    //     value : cbInfo.detail.detail.custInfo
    //   });
    //   dynamicUpdate({ key: 'cbNotify', value: false });
    //   let customerNumber =  cbInfo.detail.detail.custInfo.info.phone_number;
    //   let customerName =  cbInfo.detail.detail.custInfo.info.name;
    //   dynamicUpdate({"key":"customerNumber", "value":customerNumber })
    //   dynamicUpdate({"key":"customerName", "value":customerName })
    // } catch (error) {
    // }
    // dynamicUpdate({ key: 'cbTab', value: "dial" });
  }
  onClickDeclineBtn(){
    const { dynamicUpdate, isPreviewDial } = this.props
    dynamicUpdate({ key: 'cbTab', value: "" });
    dynamicUpdate({ key: 'cbNotify', value: false });
    dynamicUpdate({ key: 'cbInfo', value: "" });
    let nextState = isPreviewDial ? "preview" : "online";
    let message = {
      type: 'stateHandler',
      state: nextState
    };
    this.sendMessage(message);
    //state online
  }
  render() {
    const { cbInfo, callTeam, teamList } = this.props;
    let notification = "Your Callback Has been schedule now",
        name = "Unknown",
        number = "";
    if ( cbInfo && cbInfo.detail ){
      let dbInfo = cbInfo.detail || {};
      notification = dbInfo.subjectCallDetail || "Your Callback Has been schedule now";
      notification = dbInfo.subjectCallDetail || "Your Callback Has been schedule now";
      if( dbInfo.detail && dbInfo.detail.custInfo && dbInfo.detail.custInfo.info ){
        name = dbInfo.detail.custInfo.info.name
        number  = dbInfo.detail.custInfo.info.phone_number
      }
    }
    let numberMask = {};
    try {
      teamList.map(e=>{
        numberMask[e._id] = e.numberMasking || false;
      });
    } catch (error) {
    }
    number = callTeam && callTeam._id && numberMask[`${callTeam._id}`]===true?commonManager.maskText(number):number
    return (
      <CallBackNotifyTheme
        profileImg={'images/icons/male-user-1.png'}
        name={name}
        number={number}
        notification={notification}
        onClickAcceptBtn={this.onClickAcceptBtn}
        acceptBtn={'images/call-accept.svg'}
        acceptText={'Dial'}
        onClickDeclineBtn={this.onClickDeclineBtn}
        declineBtn={'images/call-decline.svg'}
        declineText={'Decline'}
      />
    )
  }
}


CallBackNotify.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  userState: globalStateSelector.getState(state),
  cbInfo: globalStateSelector.getDynamic(state, { key: 'cbInfo' }),
  isPreviewDial: globalStateSelector.getDynamic(state, { key: 'isPreviewDial' }),
  isCallbackDial: globalStateSelector.getDynamic(state, { key: 'isCallbackDial' }),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  teamList: globalStateSelector.getTeamList(state),
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  }
});

export default connect(stateToProps, dispatchToProps)(CallBackNotify);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallBackNotify.js